
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Filter } from "./Components/Filter";
import { Tabla } from "../../../components/Table/Table";
import { Eye } from "react-feather";
import DetallesModal from "./Components/DetallesModal";
import { actuacionesService } from "../../../_services/actuaciones.service";
import { Link } from "react-router-dom";
import DeudasModal from "./Components/DeudasModal";
import LoadingModal from "../../../components/LoadingModal/LoadingModal";
// import { deudasService } from "../../../_services/deudas.service";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setImponibles } from "../../../redux/Sections/titulos/action";
import { Button } from "react-bootstrap";
import moment from "moment";
import { RecursosComercios } from "../../../constants";
import "./index.css";
// import { configuracionService } from "../../../_services/configuracion.service";
import { useUser } from "../../../hooks/useUser";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import { mesasEntradaActions } from "../../../redux/MesasEntrada/actions";
import { configuracionService } from "../../../_services/configuracion.service";
import { getUltimaActuacion } from "../../../utils/actuaciones";
import { DatosModal } from "./Components/DatosModal/DatosModal";
// import { configuracionService } from "../../../_services/configuracion.service";

const Juicios = ({ abogado, setDataList, dataList, setTab, tab }) => {
  const { mesaJudicial, fechaInicial } = useSelector((e) => e.mesasEntrada);

  const dispatch = useDispatch();
  const history = useHistory();
  const user = useUser();

  const [showFilter, setShowFilter] = useState(false);
  const [showTable, setShowTable] = useState(true);

  // const [type, setType] = useState("judicial");
  const [filters, setFilters] = useState("");

  // const [resultData, setResultData] = useState([]);

  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [deudasShow, setDeudasShow] = useState(false);
  const [showLoading, setShowLoading] = useState(true);

  const [totalData, setTotalData] = useState(mesaJudicial || []);
  const [fechaInicialConfig, setFechaInicialConfig] = useState("");

  const [etapaId, setEtapaId] = useState("");

  useEffect(() => {
    dispatch(mesasEntradaActions.saveMesaJudicial(totalData));
  }, [totalData]);

  useEffect(() => {
    if (fechaInicial) {
      setFechaInicialConfig(fechaInicial);
    }
  }, [fechaInicial]);

  useEffect(() => {
    if (tab === "ACTIVOS") {
      if (mesaJudicial?.length) {
        getActivosData(mesaJudicial);
      }
      else if (!dataList?.length) {
        getData(filters);
      }
      else if (!totalData?.length) {
        getData(filters);
      } else {
        getActivosData(totalData);
      }
    }
    else if (tab === "PLAN_PAGOS") {
      getDataPlanPago(totalData);
    }
    else if (tab === "TODOS") {
      getTodosJudicial(totalData);
    } else {
      getDataSinValorar(totalData);
    }
  }, [tab]);


  const getData = async (e) => {
    setShowLoading(true);

    const res = await actuacionesService.actuacionesSearch({
      data: {
        ...e,
        abogado,
      },
      abogado,

      desde: moment().subtract(120, "day").format("YYYY-MM-DD"),
      user: user.rol

    }, "judicial");

    setTotalData(res);

    if (tab === "ACTIVOS") {
      getActivosData(res);
    } else if (tab === "SIN_EVALUAR") {
      getDataSinValorar(res);
    } else if (tab === "TODOS") {
      getTodosJudicial(res);
    } else {
      getDataPlanPago(res);
    }
    setShowLoading(false);
  };

  const actuacionesFilter = async (data) => {
    if(!data.recurso && !data.nro_imponible && !data.imponible){
      await getData(data);
    }
    else if (data?.recurso) {
      await getData(data);
    } else {
      setShowLoading(true);

      const recursos = await actuacionesService.recursosxImp({ tipo: "I", imponible: data?.nro_imponible });

      let result = [];

      for (const prop of recursos) {
        const res = await actuacionesService.actuacionesSearch({
          data: {
            ...data,
            recurso: prop.RECURSO,
            abogado,
          },
          abogado,

          desde: moment().subtract(120, "day").format("YYYY-MM-DD"),
          user: user.rol

        }, "judicial");

        if (res?.length) {
          result = result.concat(res);
        }
      }

      setTotalData(result);

      if (tab === "ACTIVOS") {
        getActivosData(result);
      } else if (tab === "SIN_EVALUAR") {
        getDataSinValorar(result);
      } else if (tab === "TODOS") {
        getTodosJudicial(result);
      } else {
        getDataPlanPago(result);
      }

      setShowLoading(false);
    }
  };

  const getTodosJudicial = async (data) => {
    setShowLoading(true);

    if (data?.length && Array.isArray(data)) {
      const filtered = data.filter((e) => {
        let historicos = e?.imponibles.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(moment(a.fecha).format("YYYY-MM-DD")) - new Date(moment(b.fecha).format("YYYY-MM-DD")));
        const actuaciones = e?.imponibles.map((imp) => imp.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        if (!historicos?.length && !actuaciones?.length) {
          return false;
        }

        let tituloEjecutivo = true;
        let judicial = true;

        if (historicos?.length) {
          const historico = historicos[historicos.length - 1];

          if (historico?.SITUACION === "Título Ejecutivo" || historico?.SITUACION === "Plan de Pagos" || historico.titulo) {
            tituloEjecutivo = true;
          } else {
            tituloEjecutivo = false;
          }

          if (actuaciones?.length) {
            let last = actuaciones[actuaciones.length - 1];

            if (new Date(last.fecha) > new Date(historico.fecha)) {
              judicial = last.tipo_etapa?.grupo === 3;
            } else {
              judicial = false;
            }
          }
        }
        else if (actuaciones?.length) {
          let last = actuaciones[actuaciones.length - 1];

          judicial = last.tipo_etapa?.grupo === 3;
        } else {
          judicial = false;
        }

        return tituloEjecutivo || judicial;
      });

      setDataList(filtered);
      setShowLoading(false);
    } else {
      setDataList([]);
      setShowLoading(false);
    }
  };

  const getActivosData = async (data) => {
    setShowLoading(true);
    // const fecha_inicial = moment().subtract(3, "month").format("YYYY-MM-DD");
    // setFechaInicialConfig(fecha_inicial);

    if (data?.length && Array.isArray(data)) {
      let fecha_inicial = fechaInicial;
      if (!fechaInicial) {
        const configuracion = await configuracionService.getConfiguracion({ key: "FECHA_INICIAL" });
        fecha_inicial = configuracion?.value;

        setFechaInicialConfig(fecha_inicial);
        dispatch(mesasEntradaActions.fechaInicial(fecha_inicial));
      }

      const filtered = data.filter((e) => {
        let tituloEjecutivo = false;

        let historicos = e?.imponibles.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(moment(a.fecha).format("YYYY-MM-DD")) - new Date(moment(b.fecha).format("YYYY-MM-DD")));

        if (historicos.length) {
          const historico = historicos[historicos.length - 1];
          // return historico?.SITUACION === "Título Ejecutivo";

          if ((historico?.SITUACION === "Título Ejecutivo" || historico.titulo) && historico?.SITUACION !== "Plan de Pagos") {
            tituloEjecutivo = new Date(historico.fecha) >= new Date(fecha_inicial);
          }
        }

        const actuaciones = e?.imponibles.map((imp) => imp.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        let judicial = false;
        if (actuaciones?.length) {
          let last = actuaciones[actuaciones.length - 1];

          judicial = last.tipo_etapa?.grupo === 3 && new Date(last.fecha).getTime() >= new Date(fecha_inicial).getTime();
        }

        return tituloEjecutivo || judicial;
      });

      setDataList(filtered);
      setShowLoading(false);
    } else {
      setDataList([]);
      setShowLoading(false);
    }
  };

  const getDataSinValorar = async (data) => {
    setShowLoading(true);

    if (data?.length && Array.isArray(data)) {
      const configuracion = await configuracionService.getConfiguracion({ key: "SIN_EVALUAR" });
      const fechaSinEnvaluar = configuracion?.value;

      const filtered = data.filter((e) => {
        let historicos = e?.imponibles.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(moment(a.fecha).format("YYYY-MM-DD")) - new Date(moment(b.fecha).format("YYYY-MM-DD")));
        const actuaciones = e?.imponibles.map((imp) => imp.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        if (!historicos?.length && !actuaciones?.length) {
          return false;
        }

        let tituloEjecutivo = true;
        let judicial = true;

        if (historicos.length) {
          const historico = historicos[historicos.length - 1];

          if ((historico?.SITUACION === "Título Ejecutivo" || historico.titulo) && historico?.SITUACION !== "Plan de Pagos") {
            tituloEjecutivo = new Date(historico.fecha) < new Date(fechaInicialConfig) && new Date(historico.fecha) >= new Date(fechaSinEnvaluar);
          }
        } else {
          tituloEjecutivo = false;
        }
        if (actuaciones?.length) {
          let last = actuaciones[actuaciones.length - 1];

          judicial = last.tipo_etapa?.grupo === 3 && new Date(last.fecha) < new Date(fechaInicialConfig) && new Date(last.fecha) >= new Date(fechaSinEnvaluar);
        } else {
          judicial = false;
        }

        return tituloEjecutivo || judicial;
      });

      setDataList(filtered);
      setShowLoading(false);

    } else {
      setDataList([]);
      setShowLoading(false);
    }
  };

  const getDataPlanPago = async (data) => {
    setShowLoading(true);

    if (data?.length && Array.isArray(data)) {
      const filtered = data.filter((e) => {
        let plandepago = "";

        let historicos = e?.imponibles.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(moment(a.fecha).format("YYYY-MM-DD")) - new Date(moment(b.fecha).format("YYYY-MM-DD")));

        if (historicos.length) {
          const historico = historicos[historicos.length - 1];

          if (historico?.SITUACION === "Plan de Pagos") {
            // plandepago = new Date(historico.fecha) >= new Date(fechaInicialConfig);
            plandepago = historico?.SITUACION === "Plan de Pagos";

            const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

            if (actuaciones?.length) {
              let last = actuaciones[actuaciones.length - 1];

              plandepago = new Date(last.fecha).getTime() < new Date(historico.fecha).getTime();
            }
          }
        }
        return plandepago;
      });

      setDataList(filtered);
      setShowLoading(false);
    } else {
      setDataList([]);
      setShowLoading(false);
    }
  };

  const handleShow = (e) => {
    setData(e);
    setShow(true);
  };

  const handleClose = () => {
    setData([]);
    setShow(false);
  };

  const handleCloseDeudas = () => {
    setData([]);
    setDeudasShow(false);
  };

  const handleTitulos = (e) => {
    dispatch(setImponibles(e));
    history.push("titulos");
  };

  const columns = [
    {
      title: "ABOGADO",
      dataIndex: "abogado",
      hidden: user.abogado !== "A00"
    },
    {
      title: "CONTRIBUYENTE",
      dataIndex: "apellnom",
    },
    {
      title: "IMPONIBLE",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <Eye
              className="mx-2 action-table"
              onClick={() => handleShow(row)}
            />
          </div>
        );
      },
    },
    {
      title: "TITULO",
      dataIndex: "titulo",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <Button
              className="custom-button mx-2"
              onClick={() => handleTitulos(row)}
            >
              Titulos
            </Button>
          </div>
        );
      },
      hidden: user.rol === "guest"
    },
    {
      title: "RECURSOS",
      dataIndex: "recursos",
      render: (a, row) => {
        const imponibles = row.imponibles?.reduce((prev, current) => {
          const repeat = prev.some((e) => e === current.RECURSO);

          return repeat ? prev : [...prev, current.RECURSO];
        }, []);
        return (
          <div>
            {row.imponibles?.length && imponibles.map((e, i) => {
              return (
                <div key={`rec_${i}`}>{e}</div>
              );
            })}
          </div>
        );
      },
    },
    {
      title: "EXPTE JUDICIAL",
      dataIndex: "id_etapa",
      render: (a, row) => {
        return row?.id_etapa ? (
          <div className="d-flex">
            <Eye style={{ cursor: "pointer" }} onClick={() => setEtapaId(row?.id_etapa)} />
          </div>
        ) : null;
      },
    },
    {
      title: "SITUACIÓN",
      dataIndex: "situacion",
    },
    {
      title: "ULTIMA ACTUALIZACIÓN",
      dataIndex: "ultima_fecha",
    },
    {
      title: "FECHA LIMITE",
      dataIndex: "fecha_limite",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <div className={!row.sin_color ? row.color_dias : ""}>
              {row.fecha_limite}
            </div>
          </div>
        );
      },
    },
    {
      title: "ACTUACIONES",
      dataIndex: "accion",
      render: (a, row) => {
        let tipo = "";
        let recurso = "";
        if (row.imponibles?.length) {
          const recursos = row.imponibles?.reduce((prev, current) => {
            const repeat = prev.some((e) => e === current.RECURSO);

            return repeat ? prev : [...prev, current.RECURSO];
          }, []);

          recurso = recursos?.length ? recursos[recursos.length - 1] : "";
        }
        if (recurso) {
          tipo = RecursosComercios.includes(recurso) ? "comercios" : "inmuebles";
        }

        const actuacion = getUltimaActuacion(row);

        return (
          // tab === "ACTIVOS" && (
          <div className="d-flex">
            <div>
              <Link className="nav-link" to={`/gestion?grupo=${3}&tipo=${tipo}&nombre=${row.apellnom || row.APYNOM}&imponible=${actuacion.NRO_IMPONIBLE || actuacion.imponible}&recurso=${actuacion.RECURSO || actuacion.recurso}&abogado=${row.abogado}`}>Ir a gestión</Link>
            </div>
          </div>
          // )
        );
      },
      hidden: user.rol === "guest"
    },
  ];

  const formatData = (arrayData) => {
    try {
      if (!arrayData?.length || !Array.isArray(arrayData)) {
        // setShowLoading(false);
        return [];
      }
      return arrayData.map((item) => {
        let fecha_limite = "";
        let ultima_fecha = "";
        let color_dias = "";
        let situacion = "";
        let id_etapa = "";

        if (item?.imponibles?.length) {
          const imponibles = item.imponibles.filter(e => e?.actuaciones?.length);
          const imponible = imponibles[imponibles.length - 1];

          if (imponible?.actuaciones?.length) {
            const actuaciones = imponible.actuaciones.sort((a, b) => new Date(a?.fecha) - new Date(b?.fecha));
            const actuacion = actuaciones[actuaciones.length - 1];

            ultima_fecha = actuacion.fecha;

            const dias_agregados = moment(actuacion.fecha).add((actuacion?.tipo_etapa?.tiempo), (actuacion?.tipo_etapa?.tipo_tiempo));
            fecha_limite = dias_agregados.format("DD/MM/YYYY");

            color_dias = new Date(dias_agregados.format("YYYY-MM-DD")).getTime() >= new Date().getTime() ? "a-tiempo" : "vencido";

            situacion = actuacion?.tipo_etapa?.grupo === 3 ? "Título Ejecutivo" : "";

            const radicacion = imponible.actuaciones?.find(ac => ac.etp01 && (+ac.imponible === +imponible.IMPONIBLE) && ac.recurso === imponible.RECURSO);

            if (radicacion) {
              id_etapa = radicacion.id_etapa;
            }
          }

          let historicos = item?.imponibles.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a?.fecha) - new Date(b?.fecha));

          if (historicos?.length) {
            const historico = historicos[historicos.length - 1];
            if (imponible?.actuaciones?.length) {
              const actuaciones = imponible.actuaciones.sort((a, b) => new Date(a?.fecha) - new Date(b?.fecha));
              const actuacion = actuaciones[actuaciones.length - 1];
              // const radicacion = imponible.actuaciones.find(ac => ac?.etp01);

              const radicacion = imponible.actuaciones?.find(ac => ac.etp01 && (+ac.imponible === +imponible.IMPONIBLE || +ac.imponible === +historico.NRO_IMPONIBLE) && ac.recurso === imponible.RECURSO);
              
              if (new Date(historico.fecha) > new Date(actuacion.fecha)) {
                ultima_fecha = historico.fecha;

                const dias_agregados = moment(historico.fecha).add((60), ("day"));
                fecha_limite = dias_agregados.format("DD/MM/YYYY");

                color_dias = new Date(dias_agregados.format("YYYY-MM-DD")).getTime() >= new Date().getTime() ? "a-tiempo" : "vencido";
                situacion = historico.SITUACION;
              }
              if (radicacion) {
                id_etapa = radicacion.id_etapa;
              }
            } else {
              ultima_fecha = historico.fecha;
              const dias_agregados = moment(historico.fecha).add((60), ("day"));
              fecha_limite = dias_agregados.format("DD/MM/YYYY");

              color_dias = new Date(dias_agregados.format("YYYY-MM-DD")).getTime() >= new Date().getTime() ? "a-tiempo" : "vencido";
              situacion = historico.SITUACION;
            }
          }
        }

        return {
          ...item,
          categorias: [
            "1 con cap contr",
          ],
          ultima_fecha: moment(ultima_fecha).format("DD/MM/YYYY"),
          fecha_limite,
          color_dias,
          sin_color: new Date(ultima_fecha) < new Date(fechaInicialConfig) || tab === "SIN_EVALUAR",
          situacion,
          tab,
          id_etapa
        };
      });
    }
    catch (err) {
      setShowLoading(false);
      console.log(err);
      return [];
    }
  };

  function exportData(list) {
    let filename = `mesajudicial_${new Date().getTime()}.xlsx`;

    const dataList = list.reduce((prev, current) => {
      let arr = [];

      if (current.imponibles?.length) {
        arr = current.imponibles.reduce((prevImps, e) => {
          if (!prevImps.some(p => (p["IMPONIBLE"] === e.IMPONIBLE || p["IMPONIBLE"] === e.NRO_IMPONIBLE) && p["RECURSO"] === e.RECURSO)) {
            let fecha = e.historico?.fecha || "";

            if (e.actuaciones?.length && !fecha) {
              const date = e.actuaciones[e.actuaciones.length - 1].fecha;

              fecha = moment(date).format("DD-MM-YYYY");
            }

            const radicacion = e.actuaciones?.find(ac => ac.etp01 && (+ac.imponible === +e.IMPONIBLE || +ac.imponible === +e.NRO_IMPONIBLE) && ac.recurso === e.RECURSO);

            return [
              ...prevImps,
              {
                "FECHA": fecha,
                "IMPONIBLE": e.IMPONIBLE || e.NRO_IMPONIBLE,
                "RECURSO": e.RECURSO,
                "ABOGADO": current.abogado,
                "CONTRIBUYENTE": current.apellnom,
                "TIPO ACTUACIÓN": radicacion?.tipo_etapa?.nombre,
                "CÁRATULA": radicacion?.etp01?.caratula,
                "NRO EXPEDIENTE": radicacion?.etp01?.nroexpte,
                "NRO TÍTULO EJECUTIVO": radicacion?.etp01?.nrotit,
                "JUZGADO": radicacion?.etp01?.juzgado,
                "MONTO": radicacion?.etp01?.monto,
                "BONO LEY 8480": (radicacion?.etp01?.cp8480 || radicacion?.etp01?.cp8480 === 0) ? radicacion?.etp01?.cp8480 ? "SI" : "NO" : "",
                "ANTICIPO PREVISIONAL": (radicacion?.etp01?.cpantprv || radicacion?.etp01?.cpantprv === 0) ? radicacion?.etp01?.cpantprv ? "SI" : "NO" : "",
                "PERIODOS": radicacion?.etp01?.periodos,
                "OBSERVACIONES": radicacion?.obs || "",
              }
            ];
          } else {
            return prevImps;
          }
        }, []);

        return [...prev, ...arr];
      } else {
        return prev;
      }
    }, []);

    let name = "Abogados";

    return {
      dataList,
      filename,
      name
    };
  }

  return (
    <div className="">
      <div className="buttons-filter">
        <h3 className="mr-3">Filtros:</h3>
        <div className="button-filter">
          {showFilter ? (
            <Button
              variant="danger"
              onClick={() => setShowFilter(false)}
              className="danger-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            >
              <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
            </Button>
          )
            : (
              <Button
                onClick={() => setShowFilter(true)}
                className="custom-button d-flex align-items-center"
                style={{ maxWidth: 105 }}
              ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
              </Button>
            )}
        </div>
      </div>
      <div className="section-filter">
        <Filter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          style={{ marginBottom: "30px" }}
          action={actuacionesFilter}
          setShowTable={setShowTable}
          setFilters={setFilters}
        />
      </div>

      {showTable ? (
        <>
          <div className="d-flex align-items-center justify-content-between">
            <div className="mb-3 fw-600" style={{ textAlign: "start" }}>
              CONTRIBUYENTES ASIGNADOS
            </div>
            { user.rol !== "guest"
              ? <div className="mb-2" style={{ maxWidth: 170 }}>
                <DescargarExcel data={exportData(dataList)} />
              </div>
              : null
            }
          </div>
          <div className="data-content">
            <div className="d-flex flex-row align-items-start section-table">
              <div className="table-tabs">
                <div className={tab === "ACTIVOS" ? "selected-table-tab" : "table-tab"} onClick={() => setTab("ACTIVOS")}>ACTIVOS</div>
                <div className={tab === "SIN_EVALUAR" ? "selected-table-tab" : "table-tab"} onClick={() => setTab("SIN_EVALUAR")}>SIN EVALUAR</div>
                <div className={tab === "PLAN_PAGOS" ? "selected-table-tab" : "table-tab"} onClick={() => setTab("PLAN_PAGOS")}>PLAN DE PAGOS</div>
                <div className={tab === "TODOS" ? "selected-table-tab" : "table-tab"} onClick={() => setTab("TODOS")}>TODOS</div>
                {
                  user.rol !== "guest"
                    ? <div className={"table-tab"} onClick={() => history.push(`/gestion?grupo=${3}&tipo=inmuebles&historico=true&abogado=${abogado}`)}>BUSCAR HISTORICO</div>
                    : null
                }
              </div>
              <div className="data-table">
                <Tabla
                  dataList={formatData(dataList)}
                  columns={columns}
                // setPage={setPage}
                // setLimit={setLimit}
                />
              </div>
            </div>
          </div>
        </>
      ) : null}

      {show && <DetallesModal show={show} handleClose={handleClose} data={data} />}
      {deudasShow && <DeudasModal show={deudasShow} handleClose={handleCloseDeudas} imponibles={data} />}
      {showLoading && <LoadingModal show={showLoading} loading mesas grupo={3} />}
      {etapaId && <DatosModal show={etapaId} handleClose={() => setEtapaId("")} etapaId={etapaId} />}
    </div>
  );
};


export default Juicios;